<p-dialog
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [style]="{ width: '31.25rem', maxWidth: '90vw' }"
  [draggable]="false"
  [resizable]="false">
  <ng-template #header>
    <div class="dialog-header">
      <span>{{ 'SETTINGS_SMS.GATEWAY.TEST_SMS.TITLE' | translate }}</span>
    </div>
  </ng-template>

  <div class="test-sms-form">
    <p class="description">
      {{ 'SETTINGS_SMS.GATEWAY.TEST_SMS.DESCRIPTION' | translate }}
    </p>

    <div class="form-field">
      <label for="phone-number">
        {{ 'SETTINGS_SMS.GATEWAY.TEST_SMS.PHONE_NUMBER' | translate }}
        <span class="required">*</span>
      </label>
      <input
        pInputText
        id="phone-number"
        type="tel"
        [ngModel]="phoneNumber()"
        (ngModelChange)="onPhoneNumberChange($event)"
        [disabled]="testInProgress()"
        class="w-full"
        placeholder="+1234567890"
        required />
      <small class="help-text">
        {{ 'SETTINGS_SMS.GATEWAY.TEST_SMS.PHONE_HELP' | translate }}
      </small>
      @if (showError()) {
        <small class="p-error">
          {{ 'SETTINGS_SMS.GATEWAY.TEST_SMS.PHONE_ERROR' | translate }}
        </small>
      } @else {
        <small class="p-error-placeholder"></small>
      }
    </div>
  </div>

  @if (logEntries().length > 0) {
    <div class="test-log">
      @for (entry of logEntries(); track $index) {
        <div class="test-log-entry" [class.test-log-entry--success]="entry.severity === 'success'" [class.test-log-entry--error]="entry.severity === 'error'">
          {{ entry.message }}
        </div>
      }
    </div>
  }

  <ng-template #footer>
    <p-button
      [label]="'GENERAL.CLOSE' | translate"
      severity="secondary"
      [outlined]="true"
      (onClick)="onClose()" />
    <p-button
      [label]="'SETTINGS_SMS.GATEWAY.TEST_SMS.SEND_BUTTON' | translate"
      icon="pi pi-send"
      severity="primary"
      [disabled]="isSendDisabled()"
      (onClick)="onSend()" />
  </ng-template>
</p-dialog>
